export interface FaqItem {
  id: string
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    id: 'receive',
    question: 'What do I receive?',
    answer:
      'You receive the MATH MADE READY 2026 Complete Edition, including three math volumes, activity pages, answer keys and the Bonus Pack of printable support tools.',
  },
  {
    id: 'grades',
    question: 'What grades is it for?',
    answer:
      'The collection is designed for learners from Grade 1 through Grade 5.',
  },
  {
    id: 'physical',
    question: 'Is this a physical product?',
    answer:
      'No. MATH MADE READY is a digital printable product. No physical shipment is required.',
  },
  {
    id: 'print',
    question: 'Can I print the activities?',
    answer:
      'Yes. Print the pages you want to use at home or in the classroom.',
  },
  {
    id: 'audience',
    question: 'Is it for teachers or families?',
    answer:
      'It is designed for both: teachers looking for ready-to-use practice and families supporting math at home.',
  },
  {
    id: 'keys',
    question: 'Are answer keys included?',
    answer:
      'Yes. Answer keys are included with the activities where shown in the material.',
  },
  {
    id: 'reuse',
    question: 'Can I use the material more than once?',
    answer:
      'Yes. The files can be printed again as needed within one household or one classroom license.',
  },
]
